import Change from './Change';

/**
 * SmartFooter
 * Offsets a height to make room for the absolutely placed footer.
 *
 * @param element {HTML Element} Footer element to base height offset from.
 * @param reactiveElement {HTML Element} Element that should be offset by the height calculated.
 * @exports {Class} SmartFooter instance
 */
export default class SmartFooter {
  constructor(element, reactiveElement) {
    this.element = element;
    this.reactiveElement = reactiveElement;
    this.register();
    this.update();
    this.ready();
  }

  register() {
    // Listen for change event.
    Change.onChange(this.update.bind(this));
  }

  update() {
    // Update height on change event.
    const height = this.element.offsetHeight;
    this.reactiveElement.style.paddingBottom = `${height}px`;
  }

  ready() {
    // Set ready state of passed in footer element.
    this.element.classList.add('ready');
  }
}
